import { Application } from "stimulus"
import DeliveryAdressController from "../controllers/delivery_address_controller"

const application = Application.start()
application.register("delivery-address", DeliveryAdressController)
